// src/pages/ChapterSeven.js
// Chapter 7 — Bamboo Forest: Panda Theme (Titan/Panda theme)
// Goal: Introduce NEW notes B3 (low B) and C5 (high C), then play the Panda Theme.
// After a successful performance, shy pandas emerge and present Pan with a star.

import React from "react";
import ChapterTemplate from "../components/ChapterTemplate";

// 🎵 Panda Theme (key of C). Uses B3 (new low note) and C5 (new high note).
// We use melodyLines for clean line breaks on screen; the template flattens for matching.
const pandaLines = [
  // L1: C B3 C D   C D E
  ["C", "B3", "C", "D", "__", "C", "D", "E"],
  // L2:   D E     G F E D
  ["__", "D", "E", "__", "__", "G", "F", "E", "D"],
  // L3: C4  C5 C5 C5     C5  B  A  G  F
  ["C4", "C5", "C5", "C5", "__", "C5", "B", "A", "G", "F"],
  // L4: A A A A   G F E D
  ["A", "A", "A", "A", "__", "G", "F", "E", "D"],
  // L5: F F F F   E G
  ["F", "F", "F", "F", "__", "E", "G"],
  // L6: E F E   D C B3   C
  ["E", "F", "E", "__", "D", "C", "B3", "__", "C"],
];

// Flatten for safety (template will also do this internally)
const pandaMelody = pandaLines.flat().filter((t) => t && t !== "__");

// 🖼️ Story slides — introduce B3 & C5 explicitly.
// Use placeholder images; you’ll replace these later.
const ChapterSevenStory = [
  {
    image: "/images/ChapterSeven/Ch7 Slide 1.png",
    text: "Pan and Wis enter the Bamboo Forest. It’s quiet… too quiet.",
  },
  {
    image: "/images/ChapterSeven/Ch7 Slide 2.png",
    text: "Rustling all around—pandas hide among the tall shoots, waiting for a friendly tune.",
  },
  {
    image: "/images/ChapterSeven/Ch7 Slide 3.png",
    text: "Play the Panda Theme Song, and find the other Pandas" }

];

export default function ChapterSeven() {
  return (
    <ChapterTemplate
      chapterNumber={7}
      chapterTitle="Bamboo Forest — Panda Theme"
      sceneImageSrc="/images/ChapterSeven/Ch7 Slide 3.png"
      storySlides={ChapterSevenStory}
      targetMelody={pandaMelody}
      melodyLines={pandaLines}
      songTitle="Panda Theme Song (A song by Mozart)"
      companionsText={{
        wis:
          "Tip: B3 sits just left of C on the keyboard; C5 is the high, sparkling C. Breathe and keep a steady beat.",
        pan:
          "I can hear them! Let’s find B3 down low, then leap up to C5 together. You’ve got this! 🐼✨",
      }}
      // Doron sleeps in Chapters 5–9; no special flag needed here.
      unlockNextChapterPath="/chapter-8"
    />
  );
}
